import React from 'react'
import { observer } from 'mobx-react'
import KdsAuthorizationStore from '../../Stores/KdsAuthorizationStore'
import { KdsPinModal } from './KdsPinModal'

/**
 * Mounts the single global PIN prompt near the KDS root. Renders nothing until the coordinator
 * has a pending elevated action, so it stays dormant until an action routes through
 * KdsAuthorizationStore.
 */
const KdsAuthorizationPromptHostComponent = () => {
  const { pendingActionId } = KdsAuthorizationStore

  if (!pendingActionId) {
    return null
  }

  return <KdsPinModal />
}

export const KdsAuthorizationPromptHost = observer(KdsAuthorizationPromptHostComponent)
